const getSubTitle = (text) => {
  const start = text.indexOf("(");
  const end = text.indexOf(")");

  if (start === -1 || end === -1 || end < start) {
    return { title: text.trim(), subTitle: "" };
  }

  const title = (text.slice(0, start) + text.slice(end + 1)).trim();
  const subTitle = text.slice(start + 1, end).trim();

  return { title, subTitle };
};
export default getSubTitle;
